module.exports = __webpack_public_path__ + "img/badge_gray_ms-academic.2b154868.svg";